import './index.scss'
$(".product .left dl dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})